import {
	FETCH_RAPPROCHEMENT_BEGIN,
	FETCH_RAPPROCHEMENT_SUCCESS,
	FETCH_RAPPROCHEMENT_ERROR,
	IMPORT_BANCAIRE_BEGIN,
	IMPORT_BANCAIRE_SUCCESS,
	IMPORT_BANCAIRE_ERROR,
	IMPORT_BANCAIRE_RESET,
	VALIDER_RAPPROCHEMENT_BEGIN,
	VALIDER_RAPPROCHEMENT_SUCCESS,
	VALIDER_RAPPROCHEMENT_ERROR,
	VALIDER_RAPPROCHEMENT_RESET,
	IGNORER_LIGNES_BEGIN,
	IGNORER_LIGNES_SUCCESS,
	IGNORER_LIGNES_ERROR,
	DESAPPARIER_BEGIN,
	DESAPPARIER_SUCCESS,
	DESAPPARIER_ERROR,
	REOUVRIR_IGNOREE_BEGIN,
	REOUVRIR_IGNOREE_SUCCESS,
	REOUVRIR_IGNOREE_ERROR,
} from "../actions/rapprochementActions"

const initialState = {
	lignes: [],
	suggestions: { fort: [], ambigu: [], orpheline: [] },
	transactions: {},
	appariees: [],
	ignorees: [],
	fetchRapprochement: { loading: false, error: false },
	importBancaire: { saving: false, saved: false, error: false, result: null },
	validerRapprochement: {
		saving: false,
		saved: false,
		error: false,
		result: null,
	},
	ignorerLignes: { saving: false, error: false },
	desapparier: { saving: false, error: false },
	reouvrirIgnoree: { saving: false, error: false },
}

export default function rapprochementReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_RAPPROCHEMENT_BEGIN:
			return {
				...state,
				fetchRapprochement: { loading: true, error: false },
			}
		case FETCH_RAPPROCHEMENT_SUCCESS:
			return {
				...state,
				lignes: action.payload.lignes || [],
				suggestions:
					action.payload.suggestions || initialState.suggestions,
				transactions: action.payload.transactions || {},
				appariees: action.payload.appariees || [],
				ignorees: action.payload.ignorees || [],
				fetchRapprochement: { loading: false, error: false },
			}
		case FETCH_RAPPROCHEMENT_ERROR:
			return {
				...state,
				fetchRapprochement: { loading: false, error: action.payload },
			}

		case IMPORT_BANCAIRE_BEGIN:
			return {
				...state,
				importBancaire: {
					saving: true,
					saved: false,
					error: false,
					result: null,
				},
			}
		case IMPORT_BANCAIRE_SUCCESS:
			return {
				...state,
				importBancaire: {
					saving: false,
					saved: true,
					error: false,
					result: action.payload,
				},
			}
		case IMPORT_BANCAIRE_ERROR:
			return {
				...state,
				importBancaire: {
					saving: false,
					saved: false,
					error: action.payload,
					result: null,
				},
			}
		case IMPORT_BANCAIRE_RESET:
			return { ...state, importBancaire: initialState.importBancaire }

		case VALIDER_RAPPROCHEMENT_BEGIN:
			return {
				...state,
				validerRapprochement: {
					saving: true,
					saved: false,
					error: false,
					result: null,
				},
			}
		case VALIDER_RAPPROCHEMENT_SUCCESS:
			return {
				...state,
				validerRapprochement: {
					saving: false,
					saved: true,
					error: false,
					result: action.payload,
				},
			}
		case VALIDER_RAPPROCHEMENT_ERROR:
			return {
				...state,
				validerRapprochement: {
					saving: false,
					saved: false,
					error: action.payload,
					result: null,
				},
			}
		case VALIDER_RAPPROCHEMENT_RESET:
			return {
				...state,
				validerRapprochement: initialState.validerRapprochement,
			}

		case IGNORER_LIGNES_BEGIN:
			return { ...state, ignorerLignes: { saving: true, error: false } }
		case IGNORER_LIGNES_SUCCESS:
			return { ...state, ignorerLignes: { saving: false, error: false } }
		case IGNORER_LIGNES_ERROR:
			return {
				...state,
				ignorerLignes: { saving: false, error: action.payload },
			}

		case DESAPPARIER_BEGIN:
			return { ...state, desapparier: { saving: true, error: false } }
		case DESAPPARIER_SUCCESS:
			return { ...state, desapparier: { saving: false, error: false } }
		case DESAPPARIER_ERROR:
			return {
				...state,
				desapparier: { saving: false, error: action.payload },
			}

		case REOUVRIR_IGNOREE_BEGIN:
			return {
				...state,
				reouvrirIgnoree: { saving: true, error: false },
			}
		case REOUVRIR_IGNOREE_SUCCESS:
			return {
				...state,
				reouvrirIgnoree: { saving: false, error: false },
			}
		case REOUVRIR_IGNOREE_ERROR:
			return {
				...state,
				reouvrirIgnoree: { saving: false, error: action.payload },
			}

		default:
			return state
	}
}
